import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo3D from "@/components/Logo3D";
import PricingView from "@/components/PricingView";
import { useRx } from "@/context/AuthContext";

export default function PublicPricing() {
  const { authed } = useRx();
  return (
    <div className="min-h-screen bg-[#050505] relative overflow-hidden" data-testid="public-pricing-page">
      <div className="rx-ambient" />
      <header className="relative z-10 max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/"><Logo3D size={32} /></Link>
        <Link to={authed ? "/app" : "/"} className="text-sm text-gray-400 hover:text-white inline-flex items-center gap-1"><ArrowLeft size={14} /> {authed ? "Command Center" : "Home"}</Link>
      </header>
      <main className="relative z-10 px-6 py-10 pb-24"><PricingView /></main>
    </div>
  );
}
